import { Box } from '@mui/material';

import { PermissionsAlertProvider } from 'features/permissions/context/PermissionsAlertContext';

import SubscriptionAlert from './SubscriptionAlert';
// import TTSBusinessAPIPermissionsAlert from './TTSBusinessAPIPermissionsAlert';

export default function MerchantAlertsHeader() {
  return (
    <Box aria-label="Merchant Alerts">
      <PermissionsAlertProvider>
        <SubscriptionAlert />
        {/** Hide alert until dashboards are ready */}
        {/* <TTSBusinessAPIPermissionsAlert /> */}
      </PermissionsAlertProvider>
    </Box>
  );
}
